import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';
import {
  CONTENT_CATEGORY_LABELS,
  SUITABLE_GRADE_LABELS,
  type ContentCategory,
  type SuitableGrade,
} from '@shared/api.interface';

interface ActiveFiltersProps {
  category: ContentCategory | '';
  grade: SuitableGrade | '';
  search: string;
  onCategoryChange: (value: ContentCategory | '') => void;
  onGradeChange: (value: SuitableGrade | '') => void;
  onSearchChange: (value: string) => void;
  onReset: () => void;
}

export function ActiveFilters({
  category,
  grade,
  search,
  onCategoryChange,
  onGradeChange,
  onSearchChange,
  onReset,
}: ActiveFiltersProps) {
  const hasFilters = category || grade || search;

  if (!hasFilters) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs text-muted-foreground shrink-0">筛选:</span>
      
      {search && (
        <Badge variant="secondary" className="gap-1 text-xs">
          {search}
          <button
            onClick={() => onSearchChange('')}
            className="hover:text-destructive"
          >
            <X className="h-3 w-3" />
          </button>
        </Badge>
      )}

      {category && (
        <Badge variant="secondary" className="gap-1 text-xs">
          {CONTENT_CATEGORY_LABELS[category]}
          <button
            onClick={() => onCategoryChange('')}
            className="hover:text-destructive"
          >
            <X className="h-3 w-3" />
          </button>
        </Badge>
      )}

      {grade && (
        <Badge variant="secondary" className="gap-1 text-xs">
          {SUITABLE_GRADE_LABELS[grade]}
          <button
            onClick={() => onGradeChange('')}
            className="hover:text-destructive"
          >
            <X className="h-3 w-3" />
          </button>
        </Badge>
      )}

      <Button
        variant="ghost"
        size="sm"
        onClick={onReset}
        className="h-6 text-xs text-muted-foreground hover:text-foreground"
      >
        重置
      </Button>
    </div>
  );
}
